export const DOMIAN = "https://contactus.oit.co.jp/index.php/api";

export const REGISTER_USER = `${DOMIAN}/user/rgRegister`;
export const USER_LOGIN = `${DOMIAN}/user/rgLogin`;
export const SUBMIT_INFO = `${DOMIAN}/user/rgUploadCV`;
export const SUBMIT_CONTACT_US = `${DOMIAN}/user/rgUploadCU`;
export const OUT_USER = `${DOMIAN}/user/logout`;
export const USER_INFO = `${DOMIAN}/user/rgUserInfo`;
export const MEETING_CONFIG = `${DOMIAN}/meeting/createMeeting`;
export const ATTENDEE_CONFIG = `${DOMIAN}/meeting/createAttendee`;
export const USER_MEETING_LIST = `${DOMIAN}/user/rgUserMeetingList`;







// WEBPACK FOOTER //
// ./src/api/api.js